<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer004">
<p class="Ahead"><span class="com-rorohiko-pagestaker-style">xi</span></p>
<p class="_ded" id="_idParaDest-2">Dedication</p>
<p class="txni">There are women, past and present, who practice the most profound and authentic magic but cannot, for myriad reasons, call themselves <span class="ital">witch</span>. They are following the work of previous generations as they tend to and reweave their communities with all the skills they own. We owe them more than we can ever repay. This book is for them. We stand together shoulder to shoulder, hip to hip, and calf to wheel.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Ded.vue?6cf8adc0